// src/routes/PageRender.jsx
import Homepage from "../../Homepage/Homepage";
import About from "../../pages/AboutPage/page/About";
import AboutLanding from "../../pages/AboutPage/page/AboutLanding";
import AboutMilestone from "../../pages/AboutPage/page/AboutMilestone";
import AboutPartner from "../../pages/AboutPage/page/AboutPartner";
import BlogLanding from "../../pages/BlogPage/page/BlogLanding";
import CareerLanding from "../../pages/CareerPage/page/CareerLanding";
import Contact from "../../pages/ContactPage/page/Contact";
import Destination from "../../pages/DestinationPage/page/Destination";
import Event from "../../pages/EventPage/page/Event";
import Franchise from "../../pages/FranchisePage/page/Franchise";
import GeneralPage from "../../pages/GeneralPage/Page/generalPage";
import TestPreparation from "../../pages/TestPreparationPage/page/TestPreparation";

const PAGE_TYPE_COMPONENT = {
  "study-abroad": Destination,
  "test-preparation": TestPreparation,
  "blog": BlogLanding,
  "events": Event,
  "contact": Contact,
  "test-preparation": TestPreparation,
  "travel": TestPreparation,
  "oshc-ovhc": TestPreparation,
  "visa-migration": TestPreparation,

};

const PageRenderer = ({ pageData }) => {
  console.log("Resolved page:", pageData);
  let Component
  if (pageData?.isPdf === true) {
    <Homepage />
  } else {


    Component = PAGE_TYPE_COMPONENT[pageData.slug] || GeneralPage;
  }

  return <Component pageData={pageData} />;
};

export default PageRenderer;
